const fields = [
 
  {
    key: "businessName",
    title: "Business Name",
    mappedField: "businessName",
    component: "Drawer",
  },
  {
    key: "businessMobileNumber",
    title: "Contact Details",
    mappedField: "businessMobileNumber",
    component: "ContactButton",
  },
  {
    key: "businessEmail",
    title: "Business Email",
    mappedField: "businessEmail",
    component: "EmailButton",
  },
  // {
  //   key: "headOffice",
  //   title: "Head Office",
  //   mappedField: "headOffice",
  //   component: "Text",
  // },
  {
    key: "addresses_city",
    title: "Head Office",
    mappedField: "addresses_city",
    component: "Text",
  },
//   {
//     key: "headOffice",
//     title: "Head Office",
//     mappedField: "headOffice",
//     component: "Text",
//     render: (data) => {
//         if (!data.addresses_line1 && !data.addresses_city) return "N/A"; // Handle empty case

//         return [
//             data.addresses_line1,
//             data.addresses_line2,
//             data.addresses_city,
//             data.addresses_state,
//             data.addresses_country
//         ]
//         .filter(Boolean) // Remove `undefined` or empty values
//         .join(", ");
//     }
// },

 
  // {
  //   key: "serviceNames",
  //   title: "Services",
  //   mappedField: "serviceNames",
  //   component: "ViewMore",
  // },
  {
    key: "clientNames",
    title: "Clients",
    mappedField: "clientNames",
    component: "ViewMore",
  },
  {
    key: "gstNumber",
    title: "GST Number",
    mappedField: "gstNumber",
    component: "Text",
  },
  {
    key: "annualTurnOver",
    title: "Turnover",
    mappedField: "annualTurnOver",
    component: "Text",
  },
  {
    key: "businessWebsite",
    title: "Website",
    mappedField: "businessWebsite",
    component: "Text",
  },
  {
    key: "establishYear",
    title: "Established Year",
    mappedField: "establishYear",
    component: "Text",
  },
 
  // {
  //   key: "serviceOffered",
  //   title: "Service Offered",
  //   mappedField: "serviceOffered",
  //   component: "ServicePopup",
  // },
  // {
  //   key: "domains",
  //   title: "Sector",
  //   mappedField: "domains",
  //   component: "ViewMore",
  // },
  // {
  //   key: "projectNames",
  //   title: "Projects",
  //   mappedField: "projectNames",
  //   component: "ViewMore",
  // },
  // {
  //   key: "gstCertified",
  //   title: "GST Status",
  //   mappedField: "gstCertified",
  //   component: "Text",
  // },
  // {
  //   key: "businessType",
  //   title: "Business Type",
  //   mappedField: "businessType",
  //   component: "Text",
  // },
];

export default fields;
